export default __webpack_public_path__ + "static/media/NoamDavidElbaz.effae311.png";